import {useTranslation} from "@i18n/client";
import React from "react";
import {I18nNamespace} from "@i18n";

import {distToText} from "../../../../../utils/distToText";

/**
 * Adds a border and title to children
 */
const SlotGroupBorder = ({
  name,
  distance,
  children,
}: React.PropsWithChildren<{
  /**
   * The name of the location
   */
  name: string;
  /**
   * The distance in miles to the location
   */
  distance?: number;
}>) => {
  const {t} = useTranslation(I18nNamespace.WEB_SCHEDULING);
  return (
    <div className="flex flex-col items-center gap-4 rounded-2xl w-full border border-gray-200 border-solid p-4">
      <em className="self-start font-ir not-italic">
        {[name, distToText(t, distance, "web-scheduling")].join(" · ")}
      </em>
      {children}
    </div>
  );
};

export default React.memo(SlotGroupBorder);
